import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { ApiError, NameSpace, SliceStatus } from 'src/Redux/types'
import { setApiError } from 'src/Hooks/redux'

import { getAudienceTiktok } from './api-actions'

export interface AudienceTiktokState {
  estimatedMinVideos: number
  estimatedMaxVideos: number
  minViews: string
  maxViews: string
  price: number
  error: ApiError | null
  status: SliceStatus
}

const initialState: AudienceTiktokState = {
  maxViews: '',
  minViews: '',
  estimatedMinVideos: 0,
  estimatedMaxVideos: 0,
  price: 0,
  error: null,
  status: SliceStatus.Idle,
}

export const audienceTiktokSlice = createSlice({
  initialState,
  name: NameSpace.AudienceTiktok,
  reducers: {
    updateCampaignPrice: (state, { payload }: PayloadAction<number>) => {
      state.price = payload
    },
    resetAudienceTiktok: () => initialState,
  },
  extraReducers(builder) {
    builder.addCase(getAudienceTiktok.pending, (state) => {
      state.status = SliceStatus.Loading
    })
    builder.addCase(getAudienceTiktok.fulfilled, (state, { payload }) => {
      state.status = SliceStatus.Succeeded
      state.estimatedMinVideos = Math.floor(payload.videos.min)
      state.estimatedMaxVideos = Math.floor(payload.videos.max)
      state.minViews = payload.viewsMedian.min
      state.maxViews = payload.viewsMedian.max
      state.price = payload.price
    })
    builder.addCase(getAudienceTiktok.rejected, (state, action) => {
      state.status = SliceStatus.Failed
      state.error = setApiError(action)
    })
  },
})

export const { updateCampaignPrice, resetAudienceTiktok } =
  audienceTiktokSlice.actions
